export default __webpack_public_path__ + "static/media/bank.6015c2dd.png";